import React from 'react';
import { Parser as HtmlToReactParser, ProcessNodeDefinitions } from 'html-to-react';
import { union } from 'lodash/array';

import { CopyToClipboardInput } from '../components/copyToClipboard';

function parseHtml(html, extraProcessingInstructions = null) {
  const processNodeDefinitions = new ProcessNodeDefinitions(React);
  let processingInstructions = [
    {
      shouldProcessNode: node => {
        return node.attribs && 'data-copy-to-clipboard' in node.attribs;
      },
      processNode: (node) => {
        const copyValue = node.attribs.value;
        return (
          <CopyToClipboardInput copyValue={ copyValue } />
        );
      },
    },
    {
      shouldProcessNode: () => true,
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ];

  if (extraProcessingInstructions) {
    processingInstructions = union(extraProcessingInstructions, processingInstructions);
  }
  const htmlToReactParser = new HtmlToReactParser();
  return htmlToReactParser.parseWithInstructions(html, () => true, processingInstructions);
}

export default parseHtml;
